<template lang="pug">
.standard
  #breadCrumb.container.d-flex.my-3
    router-link(to="/" v-if="categoryName").mb-0.text-gray.text-decoration-none 首頁
    p.mb-0.text-gray.mx-2(v-if="categoryName && categoryId") /
    router-link.mb-0.text-gray.mx-2.categoryLink.text-decoration-none(:to="'/productDetail/' + categoryId" v-if="categoryId") {{categoryName}}
    p.mb-0.text-gray.mx-2(v-if="categoryName") /
    p.mb-0 {{standardTitle}}
  .container
    .row
      .col-md-6
        swiper(:viewportWidth="fullWidth")
      .col-md-6
        p.productTitle(:class="{'mt-3':fullWidth <= 640}") {{originTitle}}
        p.theme-textCaption.font-weight-bold.secondTitle 選擇規格/尺寸
        p.font-weight-bold 規格
        .d-flex.align-items-end.mb-3
          .d-flex.flex-column.align-items-center.schematic(v-for="(item,idx) in productSpec" @click.prevent="direction = item.specName; specId =item.specId;")
            img.mb-2(:src="item.specThumbnail" :class="{'selected' : item.specName === direction}")
            span.fz12 {{item.specName}}
        .d-flex.align-items-center.mb-3
          label.mb-0(for="") 尺寸
          select#size.form-control.w-75.ml-3(v-model="sizeId")
            option(v-for="item in productSize" :value = "item.sizeId")  {{item.sizeDesc}}
        //- 姓名貼 帶參數進編輯器
        .mb-3(v-if="specId_sizeId_info.parameters != null")
          div.d-flex.align-items-center.mb-3(v-for="(item,idx) in specId_sizeId_info.parameters")
            label.mb-0 {{item.label}}
            input.form-control.w-75.ml-3(v-if="item.tag == 'input'" v-model="item.value")
            textarea.form-control.w-75.ml-3(v-if="item.tag == 'textarea'" v-model="item.value")
        hr
        p.theme-textCaption.font-weight-bold.secondTitle 產品資訊
          .row
            .col-4
              p 規格
            .col-8
              p {{direction}}
          .row(v-for="(itm, idx) in specId_sizeId_info.productIntroLeftCol")
            .col-4
              p {{itm}}
            .col-8
              p(v-html="specId_sizeId_info.productIntroRightCol[idx]")
          .row(v-if="productMaster[0] && productMaster[0].enabledPdfToImg === 1 ")
            .col-4
              p 支援格式
            .col-8
              p 支援JPG與PNG上傳，若只有PDF檔案，請點選下方按鈕先進行轉檔。
        hr.mt-0
        //- 原價 DB:productinfo
        div(v-if="discountprice === null").newPlatform.theme-textCaption.d-flex.font-weight-bold.my-3 <span v-html="standardPageNotify"></span><p class="mb-0 soldPrice" ><span class="mr-2" v-if="productId === 45">每本</span><span class="fz26" >NT {{specId_sizeId_info.price | currency}}</span><span class="ml-2" v-if="specId_sizeId_info.priceRange">起</span></p>
        //- 優惠價格 DB:productdynamicmsg
        div(v-else).newPlatform.theme-textCaption.d-flex.font-weight-bold.my-3.align-items-center <span v-html="standardPageNotify"></span><p class="mb-0 discountStyle soldPrice" ><span class="mr-2" v-if="productId === 45">每本</span><span class="d-flex">NT {{specId_sizeId_info.price | currency}}</span><span class="ml-2" v-if="specId_sizeId_info.priceRange">起</span></p>
        div.font-weight-bold.text-right.text-danger.mb-3.activityPrice(v-html="discountprice")
        //- 商品頁促銷資訊 DB:productdynamicmsg
        div(class="border border-primary mb-5"  v-if="note")
          div(class="m-2" :style = "{ 'background-color': noteBgcolor, 'color': noteForecolor}" v-html="note").font-weight-bold
        //- 按鈕區: 紙材介紹,PDF轉檔,編輯教學,
        div.d-flex.btnBox
          //- 紙材介紹
          router-link(to="/paperMaterial" target="_blank" v-if="materialPage === 'Y'").btn.btn-outline-primary.font-weight-bold.btnInPage.teachEdit 紙材介紹
          //- PDF轉檔
          button(type="button" @click="clickPdfModal()" v-if="productMaster[0] && productMaster[0].enabledPdfToImg === 1 ").btn.btn-outline-primary.font-weight-bold.btnInPage.teachEdit PDF轉檔
          //- 編輯教學
          router-link(to="/serviceContent" target="_blank" v-if="categoryId !== 6 && productId !== 39").btn.btn-outline-primary.font-weight-bold.btnInPage.teachEdit 編輯教學

          //- PDF轉檔 請先登入
          div(id="plsLoginModal", tabindex="-1"
            role="dialog", aria-labelledby="plsLoginModalLabel", aria-hidden="true").modal.fade
            div.modal-dialog(role="document").modal-sm
              div.modal-content
                div.modal-body.text-center
                  h2 請先登入會員
                div.modal-footer.justify-content-center
                  button(type="button", data-dismiss="modal").btn.btn-outline-secondary 返回
                  button(@click="login()" type="button", data-dismiss="modal").btn.btn-primary 登入會員

          //- PDF轉檔
          div(id="pdfModal", tabindex="-1"
            role="dialog", aria-labelledby="pdfModalLabel", aria-hidden="true").modal.fade
            div.modal-dialog(role="document").modal-sm
              div.modal-content
                div.modal-header.justify-content-center
                  button(type="button", data-dismiss="modal", aria-label="Close").close
                    span(aria-hidden="true") &times;
                div.modal-body.text-center
                  input(id="pdfinput" type="file" class="d-none" multiple="multiple" accept=".pdf")
                  //- 選擇檔案
                  div.pdfUploadStyle.position-relative.p-3(v-show="pdfResponseFileName === ''")
                    //- 拖移檔案區塊
                    div.pdfUpload(id="pdfUpload" class="p-3")
                    h2.pb-2 PDF轉JPG
                    p.m-0 點按鈕上傳 PDF 轉檔，或把多個PDF檔拖動到這裡
                    button.btn.btn-lg.btn-danger.m-2 上傳PDF
                    p.m-0.fz12.text-danger 上傳限制：{{maxPdfInputSize}} MB，一次最多轉檔 {{maxPdfInputCount}} 個檔案
                  //- 我要上傳
                  div.p-3(v-show="pdfInuptCount != 0")
                    p.m-0 您已上傳 <span class="fz20 font-weight-bold text-danger"> {{pdfInuptCount}} </span> 個檔案
                    p.m-0.fz12.text-danger(v-if="pdfInputSize > maxPdfInputSize") 總共已超過{{maxPdfInputSize}}MB，請點選[清除]重新上傳
                    p.m-0.fz12.text-danger(v-if="pdfInuptCount > maxPdfInputCount") 總共已超過{{maxPdfInputCount}}個檔案，請點選[清除]重新上傳
                    button.btn.btn-outline-secondary.mx-2(@click="pdfInputSize=0;pdfInuptCount=0;pdfInputFile=[]") 清除
                    button.btn.btn-danger.mx-2(@click="pdfFileUpload()") 轉檔為JPG
                  //- 我要下載
                  div.p-3.pdfDownloadStyle(v-show="pdfResponseFileName != ''")
                    h2.pb-2 PDF轉JPG
                    h3 轉檔完成！
                    div
                      button.btn.btn-lg.btn-danger.m-2(@click="pdfImgFileDownload()") 下載JPG圖片
                      p.fz14.text-danger 注意：轉檔後請檢查圖檔是否正確無掉圖掉字，若有問題請另外找其他方式轉檔。
                    div
                      button.btn.btn-sm.btn-outline-secondary.mt-3(@click="pdfResponseFileName=''") 繼續上傳PDF
                div.modal-footer.justify-content-center
                  span.fz14 下載JPG後再到編輯器編輯

          //- 一般產品直接走正常流程
          //- 2022/10/14, jamei
          //- a(:href="specId_sizeId_info.link" v-if="specId_sizeId_info.cnt === 1").btn.btn-primary.font-weight-bold.btnInPage.py-0.text-white.startEdit 開始製作
          //- 2022/10/21, jamei

          //- 沒有區分風格
          //- button(v-if="specId_sizeId_info.cnt === 1 && shopCode !== YFP_SHOP" @click="startEdit(productionMode, productId, specId_sizeId_info.link, specId_sizeId_info.price, specId_sizeId_info.parameters)").btn.btn-primary.font-weight-bold.btnInPage.py-0.text-white.startEdit 開始製作

          //- 20221111 區分一般商品，與editorPrePage === 'leather-note' 且 specId === 177 時，按钮也顯示。
          button(
          v-if="specId_sizeId_info.cnt === 1 && shopCode !== YFP_SHOP && enableEdit === 1 && ((editorPrePage === 'N') || (editorPrePage === 'leather-note' && specId === 177))"
          @click="startEdit(productionMode, productId, specId_sizeId_info.link, specId_sizeId_info.price, specId_sizeId_info.parameters)"
          ).btn.btn-primary.font-weight-bold.btnInPage.py-0.text-white.startEdit 開始製作

          //- 開始製作-編輯說明modal-名片/集點卡/謝卡/明信片/喜帖-card

          button(type="button", data-toggle="modal", data-target="#exampleModal", v-if="editorPrePage === 'card' && enableEdit === 1").btn.btn-primary.font-weight-bold.py-0.text-white.startEdit.btnInPage 開始製作

          div(id="exampleModal", tabindex="-1" role="dialog", aria-labelledby="exampleModalLabel", aria-hidden="true").modal.fade
            div.modal-dialog(role="document").modal-sm
              div.modal-content
                div.modal-header
                  h5.modal-title(id="exampleModalLabel") 編輯提醒
                  button(type="button", data-dismiss="modal", aria-label="Close").close
                      span(aria-hidden="true") &times;
                div.modal-body.text-center
                  img(v-if="fullWidth > 900"  src="/static/img/edit_pc.jpg").img-fluid
                  img(v-if="fullWidth <= 900" src="/static/img/edit_mobile.png").img-fluid

                  div.modal-footer
                      button(v-if="specId_sizeId_info.cnt === 1 && shopCode !== YFP_SHOP" @click="startEdit(productionMode, productId, specId_sizeId_info.link, specId_sizeId_info.price, specId_sizeId_info.parameters)").btn.btn-primary.font-weight-bold.btnInPage.py-0.text-white.startEdit 前往製作

          //- 開始製作-編輯說明modal-數位紅包袋(54)-redenv

          button(type="button", data-toggle="modal", data-target="#redenvModal", v-if="editorPrePage === 'redenv' && enableEdit === 1").btn.btn-primary.font-weight-bold.py-0.text-white.startEdit.btnInPage 開始製作

          div(id="redenvModal", tabindex="-1"
            role="dialog", aria-labelledby="exampleModalLabel", aria-hidden="true").modal.fade
            div.modal-dialog(role="document").modal-sm
              div.modal-content
                div.modal-header
                  h5.modal-title(id="exampleModalLabel") 編輯提醒
                  button(type="button", data-dismiss="modal", aria-label="Close").close
                      span(aria-hidden="true") &times;
                div.modal-body.text-center
                  img(v-if="fullWidth > 900" src="/static/img/edit54.jpg").img-fluid
                  img(v-if="fullWidth <= 900" src="/static/img/edit54_mobile.jpg").img-fluid

                div.modal-footer
                    button(v-if="specId_sizeId_info.cnt === 1 && shopCode !== YFP_SHOP" @click="startEdit(productionMode, productId, specId_sizeId_info.link, specId_sizeId_info.price, specId_sizeId_info.parameters)").btn.btn-primary.font-weight-bold.btnInPage.py-0.text-white.startEdit 前往製作

          //- 20240828開始製作-編輯說明modal-皮革綁帶筆記本(108)-leather-note

          button(type="button", data-toggle="modal", data-target="#leather-noteModal", v-if="editorPrePage === 'leather-note'&& specId === 176 && enableEdit === 1").btn.btn-primary.font-weight-bold.py-0.text-white.startEdit.btnInPage 開始製作

          div(id="leather-noteModal", tabindex="-1"
            role="dialog", aria-labelledby="exampleModalLabel", aria-hidden="true").modal.fade
            div.modal-dialog(role="document").modal-sm
              div.modal-content
                div.modal-header
                  h5.modal-title(id="exampleModalLabel") 編輯提醒
                  button(type="button", data-dismiss="modal", aria-label="Close").close
                      span(aria-hidden="true") &times;
                div.modal-body.text-center
                  img(v-if="fullWidth > 900" src="/static/img/edit108.jpg").img-fluid
                  img(v-if="fullWidth <= 900" src="/static/img/edit108_mobile.jpg").img-fluid

                div.modal-footer
                    button(v-if="specId_sizeId_info.cnt === 1 && shopCode !== YFP_SHOP" @click="startEdit(productionMode, productId, specId_sizeId_info.link, specId_sizeId_info.price, specId_sizeId_info.parameters)").btn.btn-primary.font-weight-bold.btnInPage.py-0.text-white.startEdit 前往製作
          //- 20240828開始製作-編輯說明modal-皮革磁釦綁帶筆記本(109)-leather-note

          button(type="button", data-toggle="modal", data-target="#magnetic-noteModal", v-if="editorPrePage === 'magnetic-note' && enableEdit === 1").btn.btn-primary.font-weight-bold.py-0.text-white.startEdit.btnInPage 開始製作

          div(id="magnetic-noteModal", tabindex="-1"
            role="dialog", aria-labelledby="exampleModalLabel", aria-hidden="true").modal.fade
            div.modal-dialog(role="document").modal-sm
              div.modal-content
                div.modal-header
                  h5.modal-title(id="exampleModalLabel") 編輯提醒
                  button(type="button", data-dismiss="modal", aria-label="Close").close
                      span(aria-hidden="true") &times;
                div.modal-body.text-center
                  img(v-if="fullWidth > 900" src="/static/img/edit108.jpg").img-fluid
                  img(v-if="fullWidth <= 900" src="/static/img/edit108_mobile.jpg").img-fluid

                div.modal-footer
                    button(v-if="specId_sizeId_info.cnt === 1 && shopCode !== YFP_SHOP" @click="startEdit(productionMode, productId, specId_sizeId_info.link, specId_sizeId_info.price, specId_sizeId_info.parameters)").btn.btn-primary.font-weight-bold.btnInPage.py-0.text-white.startEdit 前往製作

          //- 開始製作-編輯說明modal-頸掛式識別證帶(90)-lanyard

          button(type="button", data-toggle="modal", data-target="#lanyardModal", v-if="editorPrePage === 'lanyard' && enableEdit === 1").btn.btn-primary.font-weight-bold.py-0.text-white.startEdit.btnInPage 開始製作

          div(id="lanyardModal", tabindex="-1"
            role="dialog", aria-labelledby="exampleModalLabel", aria-hidden="true").modal.fade
            div.modal-dialog(role="document").modal-sm
              div.modal-content
                div.modal-header
                  h5.modal-title(id="exampleModalLabel") 編輯提醒
                  button(type="button", data-dismiss="modal", aria-label="Close").close
                      span(aria-hidden="true") &times;
                div.modal-body.text-center
                  img(v-if="fullWidth > 900" src="/static/img/lanyard_edit.jpg").img-fluid
                  img(v-if="fullWidth <= 900" src="/static/img/lanyard_edit_mobile.jpg").img-fluid

                div.modal-footer
                    button(v-if="specId_sizeId_info.cnt === 1 && shopCode !== YFP_SHOP" @click="startEdit(productionMode, productId, specId_sizeId_info.link, specId_sizeId_info.price, specId_sizeId_info.parameters)").btn.btn-primary.font-weight-bold.btnInPage.py-0.text-white.startEdit 前往製作
          //- 彩色紙袋袋寬底4k-編輯說明modal-colorbag
          button(type="button", data-toggle="modal", data-target="#colorbagModal", v-if="specId_sizeId_info.cnt === 1 && editorPrePage === 'colorbag' && enableEdit === 1").btn.btn-primary.font-weight-bold.py-0.text-white.startEdit.btnInPage 開始製作

          div(id="colorbagModal", tabindex="-1"
            role="dialog", aria-labelledby="exampleModalLabel", aria-hidden="true").modal.fade
            div.modal-dialog(role="document").modal-sm
              div.modal-content
                div.modal-header
                  h5.modal-title(id="exampleModalLabel") 編輯提醒
                  button(type="button", data-dismiss="modal", aria-label="Close").close
                      span(aria-hidden="true") &times;
                div.modal-body.text-center
                  img(v-if="fullWidth > 900" src="/static/img/edit/colorpaperbag_edit.jpg").img-fluid
                  img(v-if="fullWidth <= 900" src="/static/img/edit/colorpaperbag_edit_mobile.jpg").img-fluid

                div.modal-footer
                    button(v-if="specId_sizeId_info.cnt === 1 && shopCode !== YFP_SHOP" @click="startEdit(productionMode, productId, specId_sizeId_info.link, specId_sizeId_info.price, specId_sizeId_info.parameters)").btn.btn-primary.font-weight-bold.btnInPage.py-0.text-white.startEdit 前往製作
          //- 開始製作-編輯說明modal-IG小夜燈(73)-IGLight

          button(type="button", data-toggle="modal", data-target="#IGLightModal", v-if="editorPrePage === 'IGLight' && enableEdit === 1").btn.btn-primary.font-weight-bold.py-0.text-white.startEdit.btnInPage 開始製作

          div(id="IGLightModal", tabindex="-1"
            role="dialog", aria-labelledby="exampleModalLabel", aria-hidden="true").modal.fade
            div.modal-dialog(role="document").modal-sm
              div.modal-content
                div.modal-header
                  h5.modal-title(id="exampleModalLabel") 編輯提醒
                  button(type="button", data-dismiss="modal", aria-label="Close").close
                      span(aria-hidden="true") &times;
                div.modal-body.text-center
                  img(v-if="fullWidth > 900"  src="/static/img/edit_IGLight.jpg").img-fluid
                  img(v-if="fullWidth <= 900" src="/static/img/edit_mobile_IGLight.jpg").img-fluid

                div.modal-footer
                    button(v-if="specId_sizeId_info.cnt === 1 && shopCode !== YFP_SHOP" @click="startEdit(productionMode, productId, specId_sizeId_info.link, specId_sizeId_info.price, specId_sizeId_info.parameters)").btn.btn-primary.font-weight-bold.btnInPage.py-0.text-white.startEdit 前往製作

          //- 開始製作-編輯說明modal-拼圖(71,72)-puzzle

          button(type="button", data-toggle="modal", data-target="#puzzleModal", v-if="editorPrePage === 'puzzle' && enableEdit === 1").btn.btn-primary.font-weight-bold.py-0.text-white.startEdit.btnInPage 開始製作

          div(id="puzzleModal", tabindex="-1" role="dialog", aria-labelledby="exampleModalLabel", aria-hidden="true").modal.fade
            div.modal-dialog(role="document").modal-sm
              div.modal-content
                div.modal-header
                  h5.modal-title(id="exampleModalLabel") 編輯提醒
                  button(type="button", data-dismiss="modal", aria-label="Close").close
                      span(aria-hidden="true") &times;
                div.modal-body.text-center
                  div(id="puzzleCarousel" class="carousel slide carousel-fade" data-interval="false")
                    div.carousel-inner
                      <div class="carousel-item active">
                        <img v-if="productId === 71 && fullWidth > 900"  src="/static/img/edit_puzzle_bulk.jpg" class="d-block w-100">
                        <img v-if="productId === 72 && fullWidth > 900"  src="/static/img/edit_puzzle_complete.jpg" class="d-block w-100">
                        <img v-if="productId === 71 && fullWidth <= 900" src="/static/img/edit_mobile_puzzle_bulk1.jpg" class="d-block w-100">
                        <img v-if="productId === 72 && fullWidth <= 900" src="/static/img/edit_mobile_puzzle_complete1.jpg" class="d-block w-100">
                        div.d-flex.justify-content-between.p-2
                          div
                            //- <a class="btn btn-primary" href="#puzzleCarousel" role="button" data-slide="prev"> 上一頁 </a>
                          div
                            <a class="btn btn-primary" href="#puzzleCarousel" role="button" data-slide="next"> 下一頁 </a>
                      </div>
                      <div class="carousel-item" v-if="fullWidth <= 900">
                        <img v-if="productId === 71" src="/static/img/edit_mobile_puzzle_bulk2.jpg" class="d-block w-100">
                        <img v-if="productId === 72" src="/static/img/edit_mobile_puzzle_complete2.jpg" class="d-block w-100">
                        div.d-flex.justify-content-between.p-2
                          div
                            <a class="btn btn-primary" href="#puzzleCarousel" role="button" data-slide="prev"> 上一頁 </a>
                          div
                            <a class="btn btn-primary" href="#puzzleCarousel" role="button" data-slide="next"> 下一頁 </a>
                      </div>
                      <div class="carousel-item">
                        <img v-if="fullWidth > 900"  src="/static/img/edit_puzzle2.jpg" class="d-block w-100">
                        <img v-if="fullWidth <= 900" src="/static/img/edit_mobile_puzzle3.jpg" class="d-block w-100">
                        div.d-flex.justify-content-between.p-2
                          div
                            <a class="btn btn-primary" href="#puzzleCarousel" role="button" data-slide="prev"> 上一頁 </a>
                          div
                            button(v-if="specId_sizeId_info.cnt === 1 && shopCode !== YFP_SHOP" @click="startEdit(productionMode, productId, specId_sizeId_info.link, specId_sizeId_info.price, specId_sizeId_info.parameters)").btn.btn-primary 前往製作
                      </div>

          //- 開始製作-編輯說明modal-貼紙-sticker

          button(type="button", data-toggle="modal", data-target="#editStickerModal", v-if="editorPrePage === 'sticker' && enableEdit === 1").btn.btn-primary.font-weight-bold.py-0.text-white.startEdit.btnInPage 開始製作

          div(id="editStickerModal", tabindex="-1" role="dialog", aria-labelledby="exampleModalLabel", aria-hidden="true").modal.fade
            div.modal-dialog(role="document").modal-md
              div.modal-content
                div.modal-header
                  h5.modal-title(id="exampleModalLabel") 編輯提醒
                  button(type="button" @click="startEdit(productionMode, productId, specId_sizeId_info.link, specId_sizeId_info.price, specId_sizeId_info.parameters)").close
                      span(aria-hidden="true") &times;
                div.modal-body.text-center
                  div(id="carouselSticker" class="carousel slide carousel-fade" data-interval="false" data-wrap="false")
                    div.carousel-inner
                      div.carousel-item.active
                        div.iframe-container
                          <iframe class="iframe-video" src="https://www.youtube.com/embed/odIniDD-MSg?si=FyPMc6LGoUQE-0EO" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                        p 觀看教學影片，快速了解編輯方法
                        div.d-flex.justify-content-between.p-2
                          div
                            //- <a class="btn btn-primary" href="#carouselSticker" role="button" data-slide="prev"> 上一頁 </a>
                          div
                            <a class="btn btn-primary" href="#carouselSticker" role="button" data-slide="next"> 下一頁 </a>
                      div.carousel-item
                        div.iframe-container
                          <iframe class="iframe-video" src="https://www.youtube.com/embed/M_NPa57JtKE?si=4TL4xA4k8h26Sjfa" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                        p PDF 轉檔教學
                        div.d-flex.justify-content-between.p-2
                          div
                            <a class="btn btn-primary" href="#carouselSticker" role="button" data-slide="prev"> 上一頁 </a>
                          div
                            button(v-if="specId_sizeId_info.cnt === 1 && shopCode !== YFP_SHOP" @click="startEdit(productionMode, productId, specId_sizeId_info.link, specId_sizeId_info.price, specId_sizeId_info.parameters)").btn.btn-primary 前往製作

          //- 開始製作-編輯說明modal-特殊材質貼紙-specialsticker
          button(type="button", data-toggle="modal", data-target="#editSpecialStickerModal", v-if="editorPrePage === 'specialsticker' && enableEdit === 1").btn.btn-primary.font-weight-bold.py-0.text-white.startEdit.btnInPage 開始製作

          div(id="editSpecialStickerModal", tabindex="-1" role="dialog", aria-labelledby="exampleModalLabel", aria-hidden="true").modal.fade
            div.modal-dialog(role="document").modal-md
              div.modal-content
                div.modal-header
                  h5.modal-title(id="exampleModalLabel") 編輯提醒
                  button(type="button" @click="startEdit(productionMode, productId, specId_sizeId_info.link, specId_sizeId_info.price, specId_sizeId_info.parameters)").close
                      span(aria-hidden="true") &times;
                div.modal-body.text-center
                  div(id="carouselSpecialSticker" class="carousel slide carousel-fade" data-interval="false" data-wrap="false")
                    div.carousel-inner
                      div.carousel-item.active
                        div.iframe-container
                          <iframe class="iframe-video" src="https://www.youtube.com/embed/428Vm8pbRkE?si=CX1ypqaR1AHf4QYh" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        p 觀看教學影片，快速了解編輯方法
                        div.d-flex.justify-content-between.p-2
                          div
                            //- <a class="btn btn-primary" href="#carouselSticker" role="button" data-slide="prev"> 上一頁 </a>
                          div
                            <a class="btn btn-primary" href="#carouselSpecialSticker" role="button" data-slide="next"> 下一頁 </a>
                      div.carousel-item
                        div.iframe-container
                          <iframe class="iframe-video" src="https://www.youtube.com/embed/M_NPa57JtKE?si=4TL4xA4k8h26Sjfa" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                        p PDF 轉檔教學
                        div.d-flex.justify-content-between.p-2
                          div
                            <a class="btn btn-primary" href="#carouselSpecialSticker" role="button" data-slide="prev"> 上一頁 </a>
                          div
                            button(v-if="specId_sizeId_info.cnt === 1 && shopCode !== YFP_SHOP" @click="startEdit(productionMode, productId, specId_sizeId_info.link, specId_sizeId_info.price, specId_sizeId_info.parameters)").btn.btn-primary 前往製作

          //- 2022/10/21, jamei, button(v-if="specId_sizeId_info.cnt === 1 && shopCode === 'shop2'" @click="showModal").btn.btn-primary.font-weight-bold.btnInPage.py-0.text-white.startEdit 我想製作
          button(v-if="specId_sizeId_info.cnt === 1 && shopCode === YFP_SHOP" @click="startEdit(productionMode, productId, specId_sizeId_info.link, specId_sizeId_info.price, specId_sizeId_info.parameters)").btn.btn-primary.font-weight-bold.btnInPage.py-0.text-white.startEdit 我想製作
          //- 2022/10/14, jamei, a(:href="specId_sizeId_info.link" v-if="specId_sizeId_info.cnt === 1 && productId != 28").btn.btn-primary.font-weight-bold.btnInPage.py-0.text-white.startEdit 開始製作
          //- 2022/08/03, jamei, 貼紙產品導到舊站
          //- 2022/10/14, jamei, a(:href="PRINTWEB_URL+'site/product4.php?type=64'" v-if="specId_sizeId_info.cnt === 1 && productId === 28").btn.btn-primary.font-weight-bold.btnInPage.py-0.text-white.startEdit 我想製作
          //- 區分風格 2023/08/28月曆
          //- 20240523 change router-link to button

          //- 出現選擇風格狀態按鈕的條件：
          button.btn.btn-primary.font-weight-bold.btnInPage.py-0.text-white.chooseStyle(type="button", @click="goToRouter",v-if="(specId_sizeId_info.cnt !== 1 || productId === 25) && editorPrePage !== 'updateCalendar'") 選擇風格
          //- 2024月曆停止編輯
          //- button(type="button", data-toggle="modal", data-target="#calenderModal", v-if="specId_sizeId_info.cnt !== 1 && editorPrePage === 'updateCalendar'",@click="goToRouter").btn.btn-primary.font-weight-bold.py-0.text-white.startEdit.btnInPage 選擇風格

          //- div(id="calenderModal", tabindex="-1"
          //-   role="dialog", aria-labelledby="exampleModalLabel", aria-hidden="true").modal.fade
          //-   div.modal-dialog(role="document").modal-md
          //-     div.modal-content
          //-       div.modal-header
          //-         h5.modal-title(id="exampleModalLabel") 編輯提醒
          //-         button(type="button" data-dismiss="modal" @click="startEdit(productionMode, productId, specId_sizeId_info.link, specId_sizeId_info.price, specId_sizeId_info.parameters)").close
          //-             span(aria-hidden="true") &times;
          //-       div.modal-body.text-center
          //-         img(src="/static/img/calender.png").img-fluid

          //-20240712 新增月曆停止編輯警語
          //- button(type="button", data-toggle="modal", data-target="#calenderModale", v-if="editorPrePage === 'updateCalendar' && enableEdit === 1"  ).btn.btn-primary.font-weight-bold.py-0.text-white.startEdit.btnInPage 開始製作

          //- div(id="calenderModale", tabindex="-1" role="dialog", aria-labelledby="exampleModalLabel", aria-hidden="true").modal.fade
          //-   div.modal-dialog(role="document").modal-sm
          //-     div.modal-content
          //-       div.modal-header
          //-         h5.modal-title(id="exampleModalLabel") 編輯提醒
          //-         button(type="button", data-dismiss="modal", aria-label="Close").close
          //-             span(aria-hidden="true") &times;
          //-       div.modal-body.text-center
          //-         h5.text-danger 2025年桌曆建置中，將於今年9月正式上線，敬請期待！

          //-         div.modal-footer

          button(type="button", data-toggle="modal", data-target="#colorbagModal", v-if="specId_sizeId_info.cnt === 1 && editorPrePage === 'open' && enableEdit === 1").btn.btn-primary.font-weight-bold.py-0.text-white.startEdit.btnInPage 開始製作

          //- 開始製作-編輯說明modal-名片/明信(有影片的)-vcard

          button(type="button", data-toggle="modal", data-target="#vCardModal", v-if="editorPrePage === 'vcard' && enableEdit === 1").btn.btn-primary.font-weight-bold.py-0.text-white.startEdit.btnInPage 開始製作

          div(id="vCardModal", tabindex="-1" role="dialog", aria-labelledby="exampleModalLabel", aria-hidden="true").modal.fade
            div.modal-dialog(role="document").modal-sm
              div.modal-content
                div.modal-header
                  button(type="button", data-dismiss="modal" @click="startEdit(productionMode, productId, specId_sizeId_info.link, specId_sizeId_info.price, specId_sizeId_info.parameters)").close
                    span(aria-hidden="true") &times;
                div.modal-body.text-center
                  div(id="xmasCarousel" class="carousel slide carousel-fade" data-interval="false")
                    div.carousel-inner
                      <div class="carousel-item active">
                        //- 情人節素材影片
                        div.iframe-container
                          <iframe class="iframe-video" src="https://www.youtube.com/embed/AyqGablMuaE?si=hIBYtG3pRNI9csr9" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                        div.d-flex.justify-content-between.p-2
                          div
                            //- <a class="btn btn-primary" href="#carouselSticker" role="button" data-slide="prev"> 上一頁 </a>
                          div
                            <a class="btn btn-primary" href="#xmasCarousel" role="button" data-slide="next"> 下一頁 </a>
                      </div>
                      <div class="carousel-item">
                        <img v-if="fullWidth > 900"  src="/static/img/edit_pc.jpg" class="d-block w-100" alt="edit">
                        <img v-if="fullWidth <= 900" src="/static/img/edit_mobile.png" class="d-block w-100" alt="edit">
                        div.d-flex.justify-content-between.p-2
                          div
                            <a class="btn btn-primary" href="#carouselSticker" role="button" data-slide="prev"> 上一頁 </a>
                          div
                            button(v-if="specId_sizeId_info.cnt === 1 && shopCode !== YFP_SHOP" @click="startEdit(productionMode, productId, specId_sizeId_info.link, specId_sizeId_info.price, specId_sizeId_info.parameters)").btn.btn-primary 前往製作
                      </div>

          //- 20231115 modal for video(material) start YJ

          button(type="button", data-toggle="modal", data-target="#vModal", v-if="editorPrePage === 'v' && enableEdit === 1").btn.btn-primary.font-weight-bold.py-0.text-white.startEdit.btnInPage 開始製作

          div(id="vModal", tabindex="-1"
            role="dialog", aria-labelledby="exampleModalLabel", aria-hidden="true").modal.fade
            div.modal-dialog(role="document").modal-sm
              div.modal-content
                div.modal-header
                  button(type="button", data-dismiss="modal", aria-label="Close").close
                      span(aria-hidden="true") &times;
                div.modal-body.text-center
                  div.iframe-container
                    //- 情人節素材影片
                    <iframe class="iframe-video" src="https://www.youtube.com/embed/AyqGablMuaE?si=hIBYtG3pRNI9csr9" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen ></iframe>
                div.modal-footer
                    //- button(type="button", data-dismiss="modal").btn.btn-primary 關閉
                    button(v-if="specId_sizeId_info.cnt === 1 && shopCode !== YFP_SHOP" @click="startEdit(productionMode, productId, specId_sizeId_info.link, specId_sizeId_info.price, specId_sizeId_info.parameters)").btn.btn-primary.font-weight-bold.btnInPage.py-0.text-white.startEdit 前往製作

          //- 20231115 修改 modal end (video)

  //- hr(v-if="productId === 2")
  //-.container
    //-.row
      //-.col.edit_alert(v-if="productId === 2") 編輯提醒
  //-hr(v-if="productId === 2")
  .container.mt-5.mt-md-0
    .row.justify-content-center.py-4
      h2.font-weight-bold.mb-0.text-secondary.secondTitle(v-if="productId !== 39") 產品特性
    hr(v-if="fullWidth > 640").mt-0.mb-5
  .container.specialEffectRight(v-for="(item,idx) in productFeature"  v-if="item.shopCode === null || item.shopCode === shopCode" :class="{'mb-8' : idx === (productFeature.length - 1) && (subProducts.length <= 1)}")
    .row.justify-content-center(:class="{'flex-row-reverse': idx%2 !== 0}" v-if="productId !== 73")
      .col-md-5
        .under_second_banner_des_box_left
          .glasses
            p.font-weight-bold.text-dark.under_secondbanner_des_title(:class="{'mb-3' : fullWidth <= 640}" v-html="item.featureTitle")
            //- {{item.featureTitle}}
            p.under_secondbanner_des.mb-0(:class="{'text-justify' : fullWidth <= 640}" v-html="item.featureDesc")
            //- {{item.featureDesc}}
      .col-md-7.bgSetting
        img(:src="$store.state.imgPath+item.featurePicture")
    .row.justify-content-center(:class="{'flex-row-reverse': idx%3 !== 2}" v-else)
        .col-md-5
          .under_second_banner_des_box_left
            .glasses
              p.font-weight-bold.text-dark.under_secondbanner_des_title(:class="{'mb-3' : fullWidth <= 640}" v-html="item.featureTitle")
              //- {{item.featureTitle}}
              p.under_secondbanner_des.mb-0(:class="{'text-justify' : fullWidth <= 640}" v-html="item.featureDesc")
              //- {{item.featureDesc}}
        .col-md-7.bgSetting
          img(:src="$store.state.imgPath+item.featurePicture")
    hr.my-5(:class="{'d-none' : idx === (productFeature.length - 1) && (subProducts.length <= 1)}")
  //- 網友推薦文章
  .container-fluid.mt-4(v-if="productRecommend.length > 0")
    .row.border-top.border-bottom.py-4.align-items-center.recommendArticle.flex-column
      h2.font-weight-bold.text-secondary.secondTitle.mb-4 網友推薦文章
      .eachSuggest.mb-3.py-2.px-4.bg-white.d-flex.flex-column.justify-content-center(v-for="item in productRecommend")
        .d-flex
          p.mb-0.font-weight-bold {{item.recommendName}}
          p.date.ml-auto {{item.recommendDate}}
        a(:href="item.recommendLink" target="_blank").mb-0.text-dark {{item.recommendTitle}}
  .container(v-if = "subProducts.length > 1")
    .row.py-5.justify-content-center
      h2.font-weight-bold.mb-0.text-secondary.secondTitle 您還有更多選擇
    .row.pb-5.moreChoicePicBox
      //- div(@click.prevent="standard(itm.productId)" v-for="itm in subProducts" v-if="itm.productId !== productId" :key="itm.productId").col-md-3.col-6.d-flex.justify-content-center.mb-md-3.text-decoration-none
      router-link(:to="`/standard/${itm.productId}`" v-for="itm in subProducts" v-if="itm.productId !== productId" :key="itm.productId").col-md-3.col-6.d-flex.justify-content-center.mb-md-3.text-decoration-none
        .card
          .imgBox
            img.card-img-top(:src='itm.subMenuSmallImg')
          .card-body
            h5.card-title.font-weight-bold.text-secondary.text-center {{itm.productName}}
  //- Modal
  #noticeModal.modal.fade(tabindex='-1' role='dialog' aria-labelledby='exampleModalLabel' aria-hidden='true')
    .modal-dialog(role='document')
      .modal-content
        .modal-header.border-bottom-0
          button.close(type='button' @click="closeModal(specId_sizeId_info.link)")
            span(aria-hidden='true') &times;
        .modal-body
          div.font-weight-bold(id="system") PDF檔案上傳前，請閱讀下列說明：
          div(id="imgbox")
            div ● PDF版本需在1.6含以下，查驗PDF版本方式【請詳見】。
            div ● 務必移除檔案中安全線/裁切線/說明及文字等元素，否則會被視為印刷的元素之一，若印作檔案中未移除或本身圖檔解析度不夠造成的模糊，不得以該因素要求客訴重製。
            div ● 請確認上傳規格是否正確，尺寸顯示如下：
            div 商品款式： 名片(橫式) 成品尺寸：92mm X 54mm
            div 完稿尺寸： 92mm X 56mm (含出血1mm)
            //- input(type="checkbox" :id="comfirmSpec") 確認上述規格無誤
        .modal-footer
          button.btn.btn-secondary(@click="closeModal('')") 關閉
          button.btn.btn-primary(@click="closeModal(specId_sizeId_info.link)") 確定
</template>

<script>
// xmas 20231115
import loginmodal from '../loginmodal'
import navbarhead from '../navbarhead'
import navCustomize from '../navCustomize'
import swiper from '../swiperComponent'
import footerComponent from '../footer.vue'
import copyright from '../copyright'
import tpxNavbarhead from '../../components/tpxNavbarhead'
import { mapState, mapGetters, mapActions } from 'vuex'
import { mapFields } from 'vuex-map-fields'

export default {
  components: {
    loginmodal,
    navbarhead,
    navCustomize,
    swiper,
    footerComponent,
    copyright,
    tpxNavbarhead
  },
  data () {
    return {
      timer: false,
      fullWidth: document.body.clientWidth,
      // categoryId: null,
      materialPage: null,
      standardPageNotify: '',
      PRINTWEB_URL: process.env.PRINTWEB_URL,
      YFP_SHOP: 'shop2',
      productId_Sticker: 28,
      enableEdit: null,
      hiddenPageLastBtn: false,
      hiddenPageNextBtn: true,
      hiddenMakeBtn: false,
      // productId: null
      // Forecolor: null
      maxPdfInputCount: 10, // pdf上傳 最大數量
      maxPdfInputSize: 10 // pdf上傳 最大總容量
    }
  },
  computed: {
    // 從Vuex取出資料
    ...mapState({
      productSpec: (state) => state.standardModules.productSpec,
      // productInfo: state => state.standardModules.productInfo,
      productItem: (state) => state.standardModules.productItem,
      productFeature: (state) => state.standardModules.productFeature,
      originTitle: (state) => state.standardModules.originTitle,
      standardTitle: (state) => state.standardModules.standardTitle,
      productIntroDesc: (state) => state.standardModules.productIntroDesc,
      productMaster: (state) => state.standardModules.productMaster,
      categoryName: (state) => state.standardModules.categoryName,
      categoryId: (state) => state.standardModules.categoryId,
      productId: (state) => state.standardModules.productId,
      productRecommend: (state) => state.standardModules.productRecommend,
      discountprice: (state) => state.standardModules.discountprice,
      discountpriceForecolor: (state) => state.standardModules.discountpriceForecolor,
      discountpriceBgcolor: (state) => state.standardModules.discountpriceBgcolor,
      note: (state) => state.standardModules.note,
      noteForecolor: (state) => state.standardModules.noteForecolor,
      noteBgcolor: (state) => state.standardModules.noteBgcolor,
      // productDetail modules的data
      subProducts: (state) => state.productDetailModules.subProducts,
      // navbar modules 的data
      eachCategoryNumber: (state) => state.navbarModules.eachCategoryNumber,
      shopCode: (state) => state.commonShopModules.shopCode,
      productionMode: (state) => state.commonShopModules.productionMode,
      editorPrePage: (state) => state.standardModules.editorPrePage,
      specId: (state) => state.standardModules.specId,
      sizeId: (state) => state.standardModules.sizeId,
      pagination: state => state.styleSearchModules.pagination,
      activePage: state => state.styleSearchModules.activePage
    }),
    // like v-model
    ...mapFields(['direction', 'specId', 'sizeId', 'styleId']),
    ...mapFields(['pdfInuptCount', 'pdfInputSize', 'pdfInputFile', 'pdfResponseFileName']),
    ...mapGetters(['productSize', 'specId_sizeId_info']),
    /* 20240522更改取得尺寸下拉選單裡的名稱 */
    selectedSizeDesc () {
      const selectedItem = this.productSize.find(item => item.sizeId === this.sizeId)
      return selectedItem ? selectedItem.sizeDesc : ''
    }
    /*  20240522更改 */
  },
  methods: {
    ...mapActions('invoiceSearchModules', ['closeModal']),
    ...mapActions('standardModules', ['getStandardData', 'pdfFileUpload', 'pdfImgFileDownload']),
    getSubMenu () {
      let categoryId = this.$store.state.standardModules.categoryId
      this.$router.push(`/productDetail/${categoryId}`)
    },
    standard (id) {
      this.$router.push(`/standard/${id}`)
      // window.location.reload()
    },
    /*
    gtag_ReportConversion (
      url,
      adConversionId,
      adConversionLabel,
      value,
      currency
    ) {
      console.log(
        '[gtag_ReportConversion] ' +
          ' url=' +
          url +
          ' adConversionId=' +
          adConversionId +
          ' adConversionLabel=' +
          adConversionLabel
      )
      var callback = function () {
        if (typeof url !== 'undefined' && url !== null && url !== '') {
          window.location = url
        }
      }
      window.gtag('event', 'conversion', {
        send_to: adConversionId + '/' + adConversionLabel,
        value: value,
        currency: currency,
        event_callback: callback
      })
      return false
    },
    */
    startEdit (productionMode, productId, url, price, parameters) {
      window.fbq('trackCustom', 'StartMaking')
      window.gtag('event', 'conversion', {
        'send_to': 'AW-10816898747/tnjtCNjvjOYDELuN86Uo',
        'value': 1.0,
        'currency': 'TWD'
      })
      console.log(
        '[startEdit] productionMode=' +
          productionMode +
          ', url= ' +
          url +
          ', price=' +
          price
      )
      let glParam = window.google_tag_data.gl.data
      console.log(glParam)
      const vm = this
      // console.log('[startEdit] shopCode=' + vm.shopCode + ', productionMode=' + productionMode)

      // 2022/10/21, jamei, 貼紙導到大量印製/特殊需求
      // 20230202 關閉貼紙導向
      /*
      console.log(vm.shopCode)
      console.log(productId)
      if (vm.shopCode === vm.YFP_SHOP) {
      console.log(url)
      } else {
        if (productId === vm.productId_Sticker) {
          this.$router.push(`/dedicatedService`).catch((err) => {
            if (err.name === 'NavigationDuplicated') window.location.reload()
          })
          return
        }
      }
      */

      /*
      console.log('[startEdit] adConversionId=' + window.awConversionID)
      this.gtag_ReportConversion(
        null,
        window.awConversionID,
        'tnjtCNjvjOYDELuN86Uo',
        parseInt(price),
        'TWD'
      )
      window.gtag_report_conversion(
        null,
        window.gaTrackingID,
        'tnjtCNjvjOYDELuN86Uo'
      )
*/
      let querystring = ''
      if (parameters !== null && parameters !== []) {
        parameters.forEach(element => {
          querystring += '&' + element.name + '=' + encodeURI(element.value).replaceAll('%0A', '<br>')
        })
        url = url + querystring
      }
      if (productionMode === 'F') {
        vm.$store.dispatch('showModal')
      } else {
        if (url !== null && url !== '') {
          window.top.location = url
        }
      }
      // 20240524 GTM start_edit 開始編輯
      window.dataLayer.push({
        event: 'start_edit',
        categoryName: this.categoryName,
        productName: this.originTitle,
        productSpec: this.direction,
        productSize: this.selectedSizeDesc,
        templateName: null
      })
    },
    // 關閉modal
    closeModal (url) {
      console.log('[closeModal] url=' + url)
      const vm = this
      vm.$store.dispatch('closeModal')
      if (url !== null && url !== '') {
        // window.top.location = url
        alert('redirect to Pdf upload Page')
      }
    },
    changePage (itm) {
      this.$store.state.styleSearchModules.activePage = itm
    },
    prev () {
      this.$store.state.styleSearchModules.activePage -= 1
    },
    next () {
      this.$store.state.styleSearchModules.activePage += 1
    },
    hiddenBtn () {
      this.hiddenPageLastBtn = !this.hiddenPageLastBtn
      this.hiddenPageNextBtn = !this.hiddenPageNextBtn
      this.hiddenMakeBtn = !this.hiddenMakeBtn
    },
    unHiddenBtn () {
      this.hiddenPageLastBtn = !this.hiddenPageLastBtn
      this.hiddenPageNextBtn = !this.hiddenPageNextBtn
      this.hiddenMakeBtn = !this.hiddenMakeBtn
    },
    // pdf上傳需先登入會員
    clickPdfModal () {
      let basketref = window.tpxReadCookie('mawebhlbr')
      if (basketref == null) {
        $('#plsLoginModal').modal('show')
      } else {
        $('#pdfModal').modal('show')
      }
    },
    // pdf上傳
    pdfFileUpload () {
      this.$store.dispatch('pdfFileUpload')
    },
    // pdf img下載
    pdfImgFileDownload () {
      this.$store.dispatch('pdfImgFileDownload')
    },
    login () {
      window.tpxHighLevelSignInInitControl()
    },
    // GTM view_template 瀏覽風格頁
    goToRouter () {
      const templateData = {
        event: 'view_template',
        categoryName: this.categoryName,
        productName: this.originTitle,
        productSpec: this.direction,
        productSize: this.selectedSizeDesc
      }
      window.dataLayer.push(templateData)
      this.$router.push(`/styleSearchPage/${this.productId}/${this.specId}/${this.sizeId}`)
    }
  },
  mounted () {
    const vm = this
    // resize 事件
    window.onresize = () => {
      return (() => {
        vm.fullWidth = document.documentElement.clientWidth
      })()
    }
    // 2022/10/18, jamei
    vm.$store.dispatch('getShopCode')
    vm.$store.dispatch('getProductionMode', { shopCode: vm.shopCode })
    // PDF上傳
    const dropbox = document.getElementById('pdfUpload')
    const pdfinput = document.getElementById('pdfinput')
    dropbox.addEventListener('click', click, false)
    dropbox.addEventListener('drop', drop, false)
    dropbox.addEventListener('dragenter', dragenter, false)
    dropbox.addEventListener('dragover', dragover, false)
    dropbox.addEventListener('dragleave', dragleave, false)
    function click () {
      pdfinput.click()
    }
    pdfinput.addEventListener('change', (e) => {
      handleFiles(e.target.files)
    })
    function drop (e) {
      e.stopPropagation()
      e.preventDefault()
      const dt = e.dataTransfer
      const files = dt.files
      handleFiles(files)
    }
    function dragenter (e) {
      e.stopPropagation()
      e.preventDefault()
    }
    function dragover (e) {
      e.stopPropagation()
      e.preventDefault()
    }
    function dragleave (e) {
      e.stopPropagation()
      e.preventDefault()
    }
    function handleFiles (files) {
      for (var i = 0; i < files.length; i++) {
        const file = files[i]
        const filesType = /.pdf/
        if (!file.type.match(filesType)) {
          console.log(i + '.不是pdf.跳過')
          continue
        }
        vm.pdfInuptCount++
        vm.pdfInputSize += file.size / 1024 / 1024
        vm.pdfInputFile.push(file)
      }
      document.getElementById('pdfinput').value = ''
    }
  },
  watch: {
    // val 為改變的值
    fullWidth (val) {
      if (!this.timer) {
        this.fullWidth = val
        this.timer = true
        let that = this
        setTimeout(function () {
          that.timer = false
        }, 400)
      }
    },
    // navbar 載入同個component 不同id時用這個方法重取資料
    async $route (to, from) {
      console.log('[route change]')
      const vm = this
      // 取資料
      const id = this.$route.params.id
      await vm.$store.dispatch('getStandardData', { id })
      vm.materialPage = vm.productMaster[0].materialPage
      vm.enableEdit = vm.productMaster[0].enableEdit
      let categoryId = this.$store.state.standardModules.categoryId
      // vm.categoryId = categoryId
      // call productDetail.js 內的actions
      vm.$store.dispatch('getSubMenu', { categoryId })
      // 2022/10/18, jamei
      vm.$store.dispatch('getShopCode')
      vm.$store.dispatch('getProductionMode', { shopCode: vm.shopCode })
      // fix
      // let productId = vm.$store.state.standardModules.productId
      // vm.productId = productId
      // if (productId === 14 || productId === 15 || productId === 23 || productId === 25 || productId === 26) {
      //   vm.$alert()
      //   vm.$fire({
      //     imageUrl: 'https://i.imgur.com/MNy1261.png',
      //     background: '#ffffff00',
      //     // showConfirmButton: false,
      //     allowOutsideClick: false
      //   }).then(r => {
      //     console.log(r.value)
      //   })
      // }
      // 20240522 GTM view_item
      window.dataLayer.push({
        event: 'view_item',
        value: this.specId_sizeId_info.price,
        items: [{
          item_name: this.originTitle
        }]
      })
      // 202405 GTM specific_page_view
      window.dataLayer.push({
        event: 'specific_page_view',
        chinesePageTitle: `首頁 / ${this.categoryName} / ${this.standardTitle}`
      })
      console.log('尺寸', this.selectedSizeDesc)
      console.log('規格', this.direction)
    }
  },
  async created () {
    const vm = this
    // 取資料
    const id = this.$route.params.id
    await vm.$store.dispatch('getStandardData', { id })
    vm.materialPage = vm.productMaster[0].materialPage
    vm.enableEdit = vm.productMaster[0].enableEdit

    let categoryId = this.$store.state.standardModules.categoryId
    // vm.categoryId = categoryId
    // call productDetail.js 內的actions
    vm.$store.dispatch('getSubMenu', { categoryId })
    // 取得apiPath內standard 畫面行銷文字 standardPageNotify
    vm.standardPageNotify = window.standardPageNotify
    vm.hiddenPageLastBtn = false
    vm.hiddenPageNextBtn = true
    vm.hiddenMakeBtn = false

    // 20240522 GTM view_item
    window.dataLayer.push({
      event: 'view_item',
      value: this.specId_sizeId_info.price,
      items: [{
        item_name: this.originTitle
      }]
    })
    // 202405 GTM specific_page_view
    window.dataLayer.push({
      event: 'specific_page_view',
      chinesePageTitle: `首頁 / ${this.categoryName} / ${this.standardTitle}`
    })
  }
}
</script>

<style lang="scss" scoped>
$s14: 14px;
$s20: 20px;
$serif: "Microsoft JhengHei", "Noto Serif TC", serif;
.fz12 {
  font-size: 12px;
}
.fz26 {
  font-size: 26px;
}
.categoryLink {
  cursor: pointer;
}
.standard {
  width: 100%;
}
// 促銷活動樣式
.campaign {
  font-size: $s20;
  font-weight: bold;
  max-width: 1920px;
}
.beforenewyear {
  color: #5c87a6;
  font-size: 1.3rem;
  font-weight: bold;
}
@media (max-width: 640px) {
  .campaign {
    font-size: 5vw;
  }
}
.campaignBox {
  height: 60px;
  box-sizing: border-box;
  color: white;
}
.campaignDes {
  display: flex;
  justify-content: center;
  align-items: center;
}
// 產品規格設定
.productTitle {
  font-size: 24px;
  font-weight: bold;
}
.secondTitle {
  font-size: 18px;
}
.schematic {
  img {
    max-width: 50%;
    opacity: 0.5;
    &.selected {
      opacity: 1;
    }
  }
  cursor: pointer;
}
@media (min-width: 640px) {
  .schematic {
    &:hover {
      opacity: 0.5;
    }
  }
}
// 新平台上限字樣

@media (max-width: 641px) {
  .newPlatform {
    flex-direction: column;
  }
}
@media (max-width: 641px) {
  .soldPrice {
    display: flex;
    flex-shrink: 0;
  }
}
@media (min-width: 640px) {
  .soldPrice {
    margin-left: auto;
    white-space: nowrap;
    display: flex;
    flex-shrink: 0;
    align-items: center;
  }
}
@media (max-width: 641px) {
  .soldPrice {
    display: flex;
    flex-shrink: 0;
    align-items: center;
  }
}

// 頁面中的Btn樣式

.btnBox {
  justify-content: flex-end;
}

.btnInPage {
  border-radius: 5px;
  width: 150px;
  height: 35px;
  font-size: 1.2rem;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  .fa-chevron-right {
    margin-left: 37px;
  }
}
@media (min-width: 813px) {
  .btnInPage {
    padding-left: 0;
    &.teachEdit {
      margin: 0 8px;
    }
    &.startEdit {
      margin: 0 8px;
    }
  }
}
@media (max-width: 812px) {
  .btnBox {
    justify-content: center;
    flex-wrap: wrap;
  }
  .btnInPage {
    padding-left: 0;
    margin-bottom: 8px;
    &.teachEdit {
      width: 100%;
      margin-bottom: 8px;
    }
    &.startEdit,
    &.chooseStyle {
      width: 100%;
    }
  }
}

// hr 樣式
hr {
  border-top: 1px solid rgba(0, 0, 0, 0.5);
}
// 下方內容樣式
.secondTitle {
  font-size: 24px;
  font-family: $serif;
  letter-spacing: 1px;
}
// 第二個banner產品介紹樣式設定
.under_secondbanner_des_title {
  font-size: 27px;
  word-break: break-word;;
}
@media (max-width: 667px) {
  .under_secondbanner_des_title {
    // font-size: 4vw;
    margin-bottom: 0;
    font-size: 20px;
  }
}
@media (max-width: 640px) {
  .under_secondbanner_des_title {
    margin-top: 12px;
  }
}
@media (max-width: 823px) {
  .under_secondbanner_des_title {
    font-size: 22px;
  }
}
.under_secondbanner_des {
  font-size: 17px;
}
// 第二個banner產品--左邊圖片--樣式設定
.under_second_banner_des_box_right {
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
  // margin-left: 40px;
}
@media (max-width: 640px) {
  .under_second_banner_des_box_right {
    margin-left: 0;
  }
}
// 第二個banner產品--右邊圖片--樣式設定
.under_second_banner_des_box_left {
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  height: 100%;
  align-items: flex-start;
  // margin-right: 60px;
}
@media (min-width: 640px) {
  .col-md-4 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 33.33333%;
    flex: 0 0 33.33333%;
    max-width: none;
  }
}
@media (max-width: 640px) {
  .under_second_banner_des_box_left {
    align-items: center;
  }
}

// 背景圖片樣式設定
.bgSetting {
  max-width: 520px;
  height: auto;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  img {
    width: 100%;
    height: auto;
  }
}
@media (max-width: 640px) {
  .bgSetting {
    max-width: 580px;
    height: auto;
    img {
      max-width: 100%;
      height: auto;
    }
  }
}
// 網友推薦文章
.recommendArticle {
  background: #f4f4f4;
}
// 您還有更多選擇
.card {
  max-height: 320px;
  max-width: 258px;
  box-sizing: border-box;
  cursor: pointer;
  &:hover {
    .imgBox,
    .card-body {
      opacity: 0.5;
    }
  }
}
@media (max-width: 640px) {
  .card {
    margin-bottom: 46px;
  }
}
// 設定col-md-4的寬度
@media (min-width: 640px) {
  .moreChoicePicBox {
    justify-content: center;
    .col-md-4 {
      max-width: 28%;
    }
  }
}
@media (max-width: 640px) {
  .moreChoicePicBox {
    justify-content: center;
  }
}

// 您還有更多選擇  相片下方  白色部分
.card-body {
  height: 64px;
  box-sizing: border-box;
  h5 {
    margin-bottom: 0;
  }
}
@media (max-width: 640px) {
  .card-body {
    height: 40px;
    padding: 10px 0;
    font-size: 24px;
    h5 {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      font-size: 0.6em;
    }
  }
}

// 您還有更多選擇 相片部分
.imgBox {
  max-height: 258px;
  max-width: 258px;
  overflow: hidden;
  img {
    max-width: 258px;
    max-height: 258px;
    transform: scale(1, 1);
    // transition: all 1s ease-out;
    // &:hover{
    //   transform:scale(1.2,1.2);
    // }
  }
}
@media (max-width: 640px) {
  .col-6:nth-child(2n) {
    padding: 0 15px 0 5px;
  }
  .col-6:nth-child(2n + 1) {
    padding: 0 5px 0 15px;
  }
}

// 您還有更多選擇的container 設定
@media (max-width: 640px) {
  .container {
    max-width: 100%;
  }
}
@media (max-width: 640px) {
  .specialEffectRight {
    .col-md-5 {
      order: 2;
    }
    .col-md-7 {
      order: 1;
    }
  }
}
// 網友推薦
.eachSuggest {
  padding: 14px;
  // height: 120px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 8px;
  width: 100%;
  .date {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.4);
  }
  a {
    height: 20px;
    overflow: hidden;
  }
}
@media (min-width: 640px) {
  .eachSuggest {
    width: 50%;
  }
}
// footer
.footer {
  background-color: #f4f4f1;
  position: relative;
  margin-top: 40px;
}
// discount setting 活動價格
.discountStyle {
  text-decoration: line-through;
}
.activityPrice {
  margin-left: 8px;
  font-size: 20px;
  white-space: nowrap;
}
@media (max-width: 640px) {
  .activityPrice {
    margin-left: 0px;
  }
}
.theme-textCaption {
  color: #5c87a6;
  //color: theme-color("primary");
}
[data-url*="shop2"] .theme-textCaption {
  color: #f8c15c;
}
[data-url*="shop2"] .btn-primary {
  color: white;
  border-color: #f8c15c;
  background-color: #f8c15c;
}
[data-url*="shop2"] .btn-outline-primary {
  color: #f8c15c;
  border-color: #f8c15c;
}

// 輪播器
.carousel-control-next,
.carousel-control-prev /*, .carousel-indicators */ {
    top: 100%;
}
.carousel-control-next {
  opacity:1;
}
.btnEdit {
  color: #fff;
  background-color: #5c87a6;
  border-color: #5c87a6;
  border-radius: 5px;
  width: 110px;
  height: 39px;
  font-size: 21px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  .fa-chevron-right {
    margin-left: 37px;
  }
}
.btnEditNext {
  color: #fff;
  background-color: #5c87a6;
  border-color: #5c87a6;
  border-radius: 5px;
  width: 110px;
  height: 39px;
  font-size: 21px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  .fa-chevron-right {
    margin-left: 37px;
  }
}
@media (min-width: 813px) {
  .btnEdit {
    &.startEdit {
      margin: 0 8px;
    }
  }
  .btnEditNext {
    &.startEdit {
      margin: 0 8px;
    }
  }
}
@media (max-width: 812px) {
  .btnEdit {
    width: 60px;
    height: 25px;
    font-size: 12px;
    margin-bottom: 10px;
    &.startEdit {
      width: 100%;
    }
  }
  .btnEditNext {
    width: 60px;
    height: 25px;
    font-size: 12px;
    margin-bottom: 20px;
    &.startEdit {
      width: 100%;
    }
  }
  .btnInPage {
    padding-left: 0;
    margin-bottom: 8px;
    &.teachEdit {
      width: 100%;
      margin-bottom: 8px;
    }
    &.startEdit,
    &.chooseStyle {
      width: 100%;
    }
  }
  .carousel-control-next,
.carousel-control-prev /*, .carousel-indicators */ {
    top: 100%;
}
}
.mb-modal {
  margin-bottom: 120px;
}
.xmascontainer {
  position: relative;
  width: 70%;
  height: 0;
  padding-bottom: 56.25%;
  margin: 0 auto;
}
.xmasvideo {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.iframe-container {
  position: relative;
  width: 100%;
  aspect-ratio: 2/1;
  // height: 0;
  // padding-bottom: 40%;
  margin: 20px auto;
}
@media (max-width: 900px){
  .iframe-container {
    padding-bottom: 70%;
  }
}
.iframe-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.pdfUploadStyle{
  background-color: rgb(245, 245, 250);
  border-radius: 10px;
}
.pdfDownloadStyle{
  background-color: rgb(250, 245, 245);
  border-radius: 10px;
}
.pdfUploadBtn{
  background-color: rgb(229, 50, 45);
  color: #FFF;
  font-size: 20px;
  max-width: 300px;
  height: 60px;
  border-radius: 12px;
  margin: 20px auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.pdfUpload{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/standard.vue